/* Calmora redesign — shared behaviour. Assets → calmora-redesign.js */
(function () {
  var money = function (p) { return '₹' + (p / 100).toLocaleString('en-IN'); };

  /* ---- AJAX add to cart (works for cards, PDP and reels) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cal-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.cal-cart-btn span').forEach(function (el, i) {
          if (i === 0) el.textContent = money(cart.total_price); else el.textContent = cart.item_count;
        });
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400); }
        toast('Added to cart');
      })
      .catch(function () { if (btn) { btn.textContent = label; btn.disabled = false; } });
  });

  /* ---- add-on "+n more" reveal on product cards ---- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.cal-addon summary');
    if (!s) return;
    var rest = s.closest('.cal-addon').querySelector('[data-cal-addon-rest]');
    if (!rest) return;
    e.preventDefault();
    var open = rest.hidden;
    rest.hidden = !open;
    s.textContent = open ? 'Hide' : s.getAttribute('data-more') || s.textContent;
  });
  document.querySelectorAll('.cal-addon summary').forEach(function (s) { s.setAttribute('data-more', s.textContent); });

  /* ---- wishlist counter (localStorage) ---- */
  var WKEY = 'calmora:wishlist';
  var readWish = function () { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
  var paintWish = function () {
    var n = readWish().length;
    document.querySelectorAll('[data-cal-wishlist-count]').forEach(function (el) { el.textContent = n; el.style.display = n ? 'flex' : 'none'; });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cal-wish]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-cal-wish');
    var list = readWish();
    var i = list.indexOf(id);
    if (i > -1) list.splice(i, 1); else list.push(id);
    localStorage.setItem(WKEY, JSON.stringify(list));
    b.style.color = i > -1 ? '' : '#E70C65';
    paintWish();
    toast(i > -1 ? 'Removed from wishlist' : 'Saved to wishlist');
  });
  paintWish();

  /* ---- quick view (loads the PDP main block into a modal) ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cal-quick]');
    if (!b) return;
    e.preventDefault();
    var url = b.getAttribute('data-cal-quick');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var body = doc.querySelector('.cal-pdp');
      if (!body) { window.location.href = url; return; }
      var back = document.createElement('div');
      back.style.cssText = 'position:fixed;inset:0;z-index:1500;background:rgba(11,11,16,.55);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;padding:16px;overflow:auto';
      var panel = document.createElement('div');
      panel.className = 'cal';
      panel.style.cssText = 'background:#fff;border-radius:22px;max-width:1000px;width:100%;padding:22px;position:relative;max-height:92vh;overflow:auto';
      var close = document.createElement('button');
      close.type = 'button'; close.textContent = '×';
      close.style.cssText = 'position:absolute;top:14px;right:14px;width:34px;height:34px;border-radius:10px;border:none;background:#F3F3F7;font-size:18px;cursor:pointer;z-index:2';
      panel.appendChild(close); panel.appendChild(body); back.appendChild(panel);
      document.body.appendChild(back);
      var kill = function () { back.remove(); };
      close.addEventListener('click', kill);
      back.addEventListener('click', function (ev) { if (ev.target === back) kill(); });
    });
  });

  /* ---- PDP gallery thumbnails ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cal-thumb]');
    if (!t) return;
    var main = document.querySelector('[data-cal-main-image]');
    var img = t.querySelector('img');
    if (main && img) { main.src = img.getAttribute('data-full') || img.src; main.srcset = ''; }
    t.parentElement.querySelectorAll('[data-cal-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
    t.setAttribute('aria-current', 'true');
  });

  /* ---- coupon chips on the PDP ---- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cal-coupon]');
    if (!c) return;
    var code = c.getAttribute('data-cal-coupon');
    var off = parseInt(c.getAttribute('data-cal-off') || '0', 10);
    var input = document.querySelector('[data-cal-coupon-input]');
    var msg = document.querySelector('[data-cal-coupon-msg]');
    if (input) input.value = code;
    if (msg) { msg.textContent = code + ' applied · you save ₹' + off.toLocaleString('en-IN') + ' at checkout'; msg.style.color = '#0E9F6E'; }
    document.querySelectorAll('[data-cal-coupon]').forEach(function (x) { x.style.borderColor = '#D8D8E2'; });
    c.style.borderColor = '#0E9F6E';
    try { localStorage.setItem('calmora:coupon', code); } catch (err) {}
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cal-coupon-apply]')) return;
    var input = document.querySelector('[data-cal-coupon-input]');
    var msg = document.querySelector('[data-cal-coupon-msg]');
    var chip = input && document.querySelector('[data-cal-coupon="' + input.value.trim().toUpperCase() + '"]');
    if (!msg) return;
    if (chip) { chip.click(); } else { msg.textContent = 'That code is not valid on this product'; msg.style.color = '#D22'; }
  });

  /* ---- recent order notifications (demo social proof) ---- */
  var feed = document.querySelector('[data-cal-orders]');
  if (feed) {
    var data = [];
    try { data = JSON.parse(feed.getAttribute('data-cal-orders')); } catch (e) {}
    if (data.length) {
      var i = 0;
      var paint = function () {
        feed.innerHTML = [0, 1, 2].map(function (k) {
          var o = data[(i + k) % data.length];
          return '<div class="cal-orders__row' + (k === 0 ? ' is-top' : '') + '">' +
            (o.img ? '<img src="' + o.img + '" alt="">' : '') +
            '<span style="min-width:0;flex:1"><b style="display:block;font-size:12.5px;color:#16161C">' + o.name + ' · ' + o.city + '</b>' +
            '<span style="display:block;font-size:11.5px;color:#8A8A96;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">ordered ' + o.product + '</span></span>' +
            '<span style="font-size:11px;color:#9A9AA8;flex-shrink:0">' + o.time + '</span></div>';
        }).join('');
        i = (i + 1) % data.length;
      };
      paint();
      setInterval(paint, 3200);
    }
  }

  /* ---- deal-of-the-day countdown (ticks to local midnight) ---- */
  document.querySelectorAll('[data-cal-countdown]').forEach(function (box) {
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var now = new Date(), end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var t = Math.max(0, Math.floor((end - now) / 1000));
      var h = box.querySelector('[data-cal-cd="h"]'), m = box.querySelector('[data-cal-cd="m"]'), s = box.querySelector('[data-cal-cd="s"]');
      if (h) h.textContent = pad(Math.floor(t / 3600));
      if (m) m.textContent = pad(Math.floor(t / 60) % 60);
      if (s) s.textContent = pad(t % 60);
    };
    tick();
    setInterval(tick, 1000);
  });

  /* ---- trending-this-week filter chips (client-side, by product tag) ---- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cal-chip]');
    if (!chip) return;
    var wrap = chip.closest('[data-cal-trend-chips]');
    var grid = wrap && wrap.parentElement.querySelector('[data-cal-trend-grid]');
    if (!grid) return;
    wrap.querySelectorAll('[data-cal-chip]').forEach(function (b) { b.classList.remove('is-on'); });
    chip.classList.add('is-on');
    var tag = chip.getAttribute('data-cal-chip');
    grid.querySelectorAll('[data-cal-card]').forEach(function (card) {
      var tags = (card.getAttribute('data-cal-tags') || '').split(',');
      card.style.display = (!tag || tags.indexOf(tag) > -1) ? '' : 'none';
    });
  });

  /* ---- "buy it together" bundle add (adds each item sequentially) ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cal-add-bundle]');
    if (!b) return;
    var ids = (b.getAttribute('data-cal-add-bundle') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!ids.length) return;
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    var chain = Promise.resolve();
    ids.forEach(function (id) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        });
      });
    });
    chain.then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.cal-cart-btn span').forEach(function (el, i) {
          if (i === 0) el.textContent = money(cart.total_price); else el.textContent = cart.item_count;
        });
        b.textContent = 'Added ✓'; setTimeout(function () { b.textContent = label; b.disabled = false; }, 1400);
        toast('Bundle added to cart');
      })
      .catch(function () { b.textContent = label; b.disabled = false; });
  });

  /* ---- collection filter drawer on mobile ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cal-filter-toggle')) return;
    var side = document.querySelector('.cal-side');
    if (side) side.classList.toggle('is-open');
  });

  /* ---- auto-sliding rails on mobile ---- */
  setInterval(function () {
    if (window.innerWidth > 900) return;
    document.querySelectorAll('.cal-autorail').forEach(function (rail) {
      if (rail.dataset.paused === '1') return;
      var first = rail.querySelector('.cal-reel, .cal-card, .cal-cat');
      if (!first) return;
      var step = first.getBoundingClientRect().width + 12;
      var end = rail.scrollWidth - rail.clientWidth - 8;
      rail.scrollTo({ left: rail.scrollLeft >= end ? 0 : rail.scrollLeft + step, behavior: 'smooth' });
    });
  }, 3000);
  document.addEventListener('pointerdown', function (e) {
    var rail = e.target.closest && e.target.closest('.cal-autorail');
    if (!rail) return;
    rail.dataset.paused = '1';
    clearTimeout(rail._calT);
    rail._calT = setTimeout(function () { rail.dataset.paused = '0'; }, 9000);
  }, true);

  /* ---- toast ---- */
  function toast(text) {
    var t = document.createElement('div');
    t.textContent = text;
    t.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);z-index:2000;padding:11px 18px;border-radius:100px;background:#0B0B10;color:#fff;font:600 13px Inter,sans-serif;box-shadow:0 14px 30px rgba(0,0,0,.3)';
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; }, 1600);
    setTimeout(function () { t.remove(); }, 2000);
  }
})();
